export const options = {
  pageLength: 10,
  deferLoading: 50,
  paging: true,
  select: true,
  autoWidth: true,
  serverSide: true,
  processing: true,
  scrollX: true,
  fixedColumns: {
    start: 2,
  },
  order: [],
  columnDefs: [{ targets: "_all", orderable: true }],
  lengthMenu: [5, 10, 20, 40, 80, 160, 200, 500, 1000, 5000, 10000],
  pagingType: "simple_numbers",
  language: {
    lengthMenu: "Show _MENU_ entries",
    paginate: {
      next: "Next",
      previous: "Previous",
    },
    info: "Showing _START_ to _END_ of _TOTAL_ entries",
  },
  dom:
    "<'row'<'col-sm-12 col-md-6 pb-3'l><'col-sm-12 col-md-6 pb-3'f>>" +
    "<'row'<'col-sm-12'B>>" +
    "<'row'<'col-sm-12'tr>>" +
    "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 d-flex justify-content-end'p>>",
};

export const columns = [
  {
    title: "ID",
    data: "id",
    className: "fixed-column-devices-table-bg",
  },
  {
    title: "COURSE",
    data: "course",
    className: "fixed-column-devices-table-bg",
  },
  { title: "TOTAL DEVICES", data: "devices" },
  { title: "CONTRACT DEVICES", data: "contract_devices" },
  { title: "OLD FIXES", data: "old_fixes" },
  { title: "OLD FIXES #", data: "old_fixes_#" },
  { title: "PRIMARY TRACKED", data: "primary_tracked" },
  { title: "ROUND TRACKED", data: "round_tracked" },
];
